module.exports = __webpack_public_path__ + "static/media/pov_vertex_figure_GreatDodecahedron.9debb4a7.png";